import React from 'react';
import { useTranslation } from 'react-i18next';
import { helperMargin, Typography } from '@utex/ui-kit';
import { MoneyView } from '../../../components/MoneyView';
import { InstrumentCommission } from '../../../types/instrument';
import { PercentView } from '../../../components/PercentView';

interface Props {
  children: InstrumentCommission;
}

export const Commission: React.FC<Props> = ({ children: commission }) => {
  const { t } = useTranslation('toBank');

  if (!commission) {
    return null;
  }

  return (
    <Typography.Paragraph
      size="M"
      view="hint"
      css={helperMargin({ left: { tablesktop: 15 }, bottom: { phonablet: 10 } })}
    >
      {t('Commission')}
      {': '}
      {commission.__typename === 'ClearingWithdrawFixedFee' && (
        <MoneyView>{commission.amount}</MoneyView>
      )}
      {commission.__typename === 'ClearingWithdrawPercentFee' && (
        <PercentView>{commission.percent}</PercentView>
      )}
      {'. '}
      {t('The transfer will take up to N business days')}
    </Typography.Paragraph>
  );
};
